var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4.72727C4 4.32561 4.32561 4 4.72727 4H14.9091C15.3108 4 15.6364 4.32561 15.6364 4.72727V14.9091C15.6364 15.3108 15.3108 15.6364 14.9091 15.6364H4.72727C4.32561 15.6364 4 15.3108 4 14.9091V4.72727ZM5.45455 5.45455V14.1818H14.1818V5.45455H5.45455ZM17.0909 9.09091C17.0909 8.68925 17.4165 8.36364 17.8182 8.36364H19.2727C19.6744 8.36364 20 8.68925 20 9.09091V19.2727C20 19.6744 19.6744 20 19.2727 20H9.09091C8.68925 20 8.36364 19.6744 8.36364 19.2727V17.8182C8.36364 17.4165 8.68925 17.0909 9.09091 17.0909C9.49257 17.0909 9.81818 17.4165 9.81818 17.8182V18.5455H18.5455V9.81818H17.8182C17.4165 9.81818 17.0909 9.49257 17.0909 9.09091Z",
    fill: "#92929E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.16811ed62882a9d2074c1481e35336b2.svg";
export { ForwardRef as ReactComponent };